import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ng-hbm-bdi-loader',
  templateUrl: './loader.component.html'
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
